$( function() {
	initAccordion();
});

function initAccordion() {
	$('.accordion-and-image .item-title').on('click', function(e) {
		if ($(window).width() > 991) $('.accordion-and-image .item-title').not($(this)).removeClass('open');
		$(this).toggleClass('open');
		var el = $(this).next('.accordion-and-image .item-text');
		var vis = el.is(":visible");
		if ($(window).width() > 991) $('.accordion-and-image .item-text').slideUp();

		el[ vis ? "slideUp" : "slideDown"]();

		$('.accordion-and-image .images .image').addClass('d-none');
		$('#'+$(this).data('id')).removeClass('d-none');

	});
}
